/* LANGUAGE PAGE SCRIPT */

$(document).ready(function() {

  var elements = document.getElementById("ContactFormPhone");
  elements.oninvalid = function(e) {
  e.target.setCustomValidity("");
  if (!e.target.validity.valid) {
    e.target.setCustomValidity("This field must contain only numeral di");
  }
  };
  elements.oninput = function(e) {
      e.target.setCustomValidity("");
  };
  // Check if local storage is available
  if (typeof(Storage) !== "undefined") {
    // Get the current value of the "key" key in local storage
    var currentValue = localStorage.getItem("language");
    
    // When an element with class "change-value" is clicked
    $("#box-de").click(function() {
      if(currentValue === "de"){
        return
      }
      var newValue = "de";
      localStorage.setItem("language", newValue);
      location.reload();
    });

    $("#box-nl").click(function() {
      if(currentValue === "nl"){
        return
      }
      
      var newValue = "nl";
      localStorage.setItem("language", newValue);
      location.reload();
    });

    $("#box-en").click(function() {
       if(currentValue === "en"){
        return
      }
      var newValue = "en";
      localStorage.setItem("language", newValue);
      location.reload();
    });
  } else {
    // Local storage is not available
    console.log("Local storage is not available.");
  }
});

/* LANDING PAGE SLIDER */

const slider = document.querySelector(".slider-body");
const active = document.querySelector(".controller-active");
const line1 = document.querySelector(".controller-line-1");
const line2 = document.querySelector(".controller-line-2");

// Auto Slide
setInterval(auto_sliders, 5000);
function auto_sliders() {
  if (active.classList.contains("controller-auto-active")) {
    slider.style.transform = "translateX(-100%)";
    active.style.top = "80px";
    active.classList.remove("controller-auto-active");
  } else {
    slider.style.transform = "translateX(0)";
    active.style.top = "0px";
    active.classList.add("controller-auto-active");
  }
}

// Click to slide
line1.addEventListener("click", () => {
  slider.style.transform = "translateX(0)";
  active.style.top = "0px";
});

line2.addEventListener("click", () => {
  slider.style.transform = "translateX(-100%)";
  active.style.top = "80px";
});

/* LANDING PAGE BLOG SECTION */

const swiper = new Swiper(".blog-slider", {
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  spaceBetween: 30,
  effect: "fade",
  loop: true,
  mousewheel: {
    invert: false,
  },
  pagination: {
    el: ".blog-slider-pagination",
    clickable: true,
  },
});

const text = document.getElementsByClassName("truncate-text");
const title = document.getElementsByClassName("truncate-title");
const hover_out = document.getElementsByClassName("blog-slider-list-btn-read");

// Truncate title
Array.prototype.forEach.call(title, function (e) {
  const num_title = 12;
  const word_title = e.innerText || e.textContent;
  if (word_title.split(" ").length > num_title) {
    const trim = word_title.split(" ").splice(0, num_title).join(" ") + " ...";
    e.textContent = trim;
  } else {
    e.textContent = word_title;
  }
});

// Truncate text
Array.prototype.forEach.call(text, function (e) {
  const num_txt = 15;
  const word_txt = e.innerText || e.textContent;
  if (word_txt.split(" ").length > num_txt) {
    const trim = word_txt.split(" ").splice(0, num_txt).join(" ") + " ...";
    e.textContent = trim;
  } else {
    e.textContent = word_txt;
  }
});

//remove delay after hover out
Array.prototype.forEach.call(hover_out, function (e) {
  e.addEventListener("mouseout", () => {
    e.style.transitionDelay = "0s";
  });
});

//Script to enlarge video when user clicks on mission page.
$(
  ".video-container global-border-radius, .global-border-radius--not-extra-small, .video-container--image, .video-container--modal-mobile, .avoid-overlaps avoid-overlaps--processed, .video--init, .video-container--playing"
).click(function (event) {
  $(this).css({ maxHeight: "100rem" });

  $(this).center();
});

// Script to refresh page on increment / decrement of cart quantity
function quantityChange() {
            history.go(0);
                            }










